// src/pages/IdentityAuthenticationMovil.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import incode from "../services/incode";
import Steps from "../components/Steps";
import ProcessFace from '../components/ProcessFace';
import RetrySteps from "../components/RetrySteps";
import LoadingSpinner from "../components/LoadingSpinner";
import ErrorComponent from "../components/ErrorComponent";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const IdentityAuthenticationMovil = () => {
    const [transactionId, setTransactionId] = useState(null);
    const [token, setToken] = useState(null);
    const [session, setSession] = useState();
    const [step, setStep] = useState(0);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(true);    
    //const [userExists, setUserExists] = useState(false);

    useEffect(() => {
        // Obtener parámetros una sola vez
        const queryParams = new URLSearchParams(window.location.search);
        const currentTransactionId = queryParams.get("transactionId");
        const currentToken = queryParams.get("token");

        setTransactionId(currentTransactionId);
        setToken(currentToken);

        const fetchTransactionStatus = async () => {
            if (!currentTransactionId || !currentToken) return;

            try {
                setLoading(true);
                const response = await axios.get(
                    `${apiUrl}/api/v1/TransactionAuthentication/${currentTransactionId}`,
                    { headers: { Authorization: `Bearer ${currentToken}` } }
                );

                if (response.data.status === 0) { 
                   
                    const session = await incode.createSession("ALL", null, {
                        configurationId: response.data.flowId,
                    });
                    await incode.warmup();
                    setSession(session);

                    await axios.post(
                        `${apiUrl}/api/v1/Notificacion/start-authentication`,
                        currentTransactionId,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${currentToken}`,
                            },
                        }
                    );
                } else {
                    setError(true);
                    setErrorMessage("Estado de transacción no válido.");
                }
            } catch (err) {
                setError(true);
                setErrorMessage("Error al obtener el estado de la transacción.");
            } finally {
                setLoading(false);
            }
        };

        fetchTransactionStatus();
    }, []); // Dependencias vacías porque los valores se inicializan una vez


    const goNext = () => setStep((prevStep) => prevStep + 1);

 

    const handleError = async (step, errorDetails) => {

          //console.log('[handleError ▶ entrada]', { step, errorDetails, session });


        try {

            // Mostrar el error en la interfaz
            setErrorMessage("Autenticación fallida continue el proceso en el PC");
            setError(true);
    
            // Clonar el objeto errorDetails sin las imágenes
            const sanitizedErrorDetails = { ...errorDetails };
    
            if (sanitizedErrorDetails.details) {
                sanitizedErrorDetails.details = { ...sanitizedErrorDetails.details };
    
                // Remover las propiedades que contienen imágenes
                delete sanitizedErrorDetails.details.originalImage;
                delete sanitizedErrorDetails.details.frontIdImage;
                delete sanitizedErrorDetails.details.croppedIDFace;
            }
    
            // Enviar el error a la API
            const payload = {
                id: transactionId,
                transactionIncodeId: session?.interviewId,
                transactionIncodeToken: session?.token,
                step,
                errorDetails: JSON.stringify(sanitizedErrorDetails),
            };
    
            const response = await axios.put(`${apiUrl}/api/v1/TransactionAuthentication/update/error`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
    
            if (response.status !== 200 || !response.data?.urlCallback) {
                setErrorMessage("La API no respondió correctamente.");
            }

            goNext();
        } catch (err) {
            console.error("Error al reportar el error a la API:", err);
        }
    };

   
    


    const handleProcessCompletion = async (validationResult) => {
        try {
    
           
            const payload = {
                id: transactionId, // ID de la transacción
                resultIncodeAuthentication: validationResult, // Utilizar directamente validationResult
            };
    
                const response = await axios.put(
                    `${apiUrl}/api/v1/TransactionAuthentication/update`,
                    payload,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
    
               if (response.status !== 200 || !response.data?.urlCallback) {
                    setErrorMessage("La API no respondió correctamente.");
                }

                goNext();
            } catch (err) {
                setError(true);
                setErrorMessage("Error al completar el proceso.");
            }
        };
    
    

    

    if (loading) return <LoadingSpinner />;
    if (error) return <ErrorComponent message={errorMessage} />;

    return (
        session ? (
            step <  1 ? (               
               <Steps currentStep={step}>
                    <ProcessFace
                        session={session}
                        onSuccess={handleProcessCompletion}
                        onError={(e) => handleError("FaceMatch", { message: e.message, details: e })}
                        />
                    <RetrySteps
                        session={session}
                        numberOfTries={3}
                        onSuccess={goNext}                            
                        onError={(e) => handleError("RetrySteps", { message: e.message, details: e })}
                        />
                </Steps>
            ) : (
                <div>
                    <h1 style={{ textAlign: "center" }}>Has finalizado el proceso de autenticacion.</h1>
                </div>
            )    
        ) : (
              <LoadingSpinner />
        )  
    );
};

export default IdentityAuthenticationMovil;
